import { computed, getCurrentInstance } from 'vue';
import { resolveStoreId } from '@rebuild/utils/context';
import i18n from '@/assets/js/i18n';
import { proxyNavigateTo as NavigateTo } from '@/utils/navigateTo';

export function useNavigation() {
	const vm = getCurrentInstance();
	const proxy = vm.proxy;

	const currentTemplate = computed(() => {
		const tmplParam = proxy.$route.params.tmpl;
		if (tmplParam) return tmplParam;
		// 默认路径识别为 flow 类型
		return 'flow';
	});

	// 检测当前路径风格（默认风格 vs 显式风格）
	const isDefaultStyle = computed(() => {
		const tmplParam = proxy.$route.params.tmpl;
		if (tmplParam) return false;
		return true;
	});

	// 构建模板路径的工具函数
	const buildTemplatePath = (page, templateType = null) => {
		const prefix = '/irm-mobile/enterprise';
		const targetTemplate = templateType || currentTemplate.value;

		// 如果目标模板类型是 flow，可以使用两种风格
		if (targetTemplate === 'flow') {
			return isDefaultStyle.value ? `${prefix}/${page}` : `${prefix}/flow/${page}`;
		}

		const tmplId = proxy.$route.params.tmplId;
		if (tmplId) {
			return `${prefix}/${targetTemplate}/${tmplId}/${page}`;
		}

		// 其他模板类型使用显式风格
		return `${prefix}/${targetTemplate}/${page}`;
	};

	const buildTemplateQuery = (query = {}, targetPath = '') => {
		const targetQuery = {
			...query,
			lang: i18n.locale
		};

		const storeId = resolveStoreId();
		if (storeId) {
			targetQuery.storeId = storeId;
		}

		// 在首页不传递 pageType，避免模板数据受影响
		const visInHomePage = targetPath === buildTemplatePath('index');
		const { pageType, tmplId } = proxy.$route.query;
		if (!visInHomePage) {
			if (pageType) {
				targetQuery.pageType = pageType;
			}
			if (tmplId) {
				targetQuery.tmplId = tmplId;
			}
		}

		// 渠道参数同步，防止缓存取不到值的情况
		const comein_channel = localStorage.getItem('channel');
		if (comein_channel) {
			targetQuery.comein_channel = comein_channel;
		}

		return targetQuery;
	};

	// 导航方法 - 保持当前路径风格
	const navigateToPage = (page, query = {}) => {
		const path = buildTemplatePath(page);
		console.log('😪 # navigateToPage # path:', path);
		NavigateTo({ selfPath: path, query: buildTemplateQuery(query, path) });
	};
	const replaceToPage = (page, query = {}) => {
		const path = buildTemplatePath(page);
		console.log('😪 # replaceToPage # path:', path);
		proxy.$router.replace({ path, query: buildTemplateQuery(query, path) });
	};

	const goToHome = (query = {}) => navigateToPage('index', query);
	const goToModule = (moduleId, query) => navigateToPage(moduleId, query);
	const goToModuleSubPath = (moduleId, subPath, query) => navigateToPage(`${moduleId}/${subPath}`, query);

	const replaceHome = (query = {}) => replaceToPage('index', query);
	const replaceToModule = (moduleId, query) => replaceToPage(moduleId, query);
	const replaceModuleSubPath = (moduleId, subPath, query) => replaceToPage(`${moduleId}/${subPath}`, query);

	return {
		currentTemplate,

		// 方法
		buildTemplatePath,
		buildTemplateQuery,
		navigateToPage,

		// 便捷导航方法
		goToHome,
		goToModule,
		goToModuleSubPath,
		replaceHome,
		replaceToModule,
		replaceModuleSubPath
	};
}
